/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
/**
 * Необходимо для создания начального состояния полей для создания строчек таблицы
 */
export const initialMS = [
	{ td: "Наименование и тип технического средства (маркировка)", value: "", key: "name", required: true },
	{ td: "Сведения о сертификате", value: "", key: "type", required: false },
	{ td: "Место и дата упаковки", value: "", key: "code", required: false },
	// { td: "Поставщик", value: "", key: "provider", required: false },
	// { td: "Единица измерения", value: "", key: "unit", required: false },
	// { td: "Количество", value: "", key: "quantity", required: false },
	// { td: "Масса единицы, кг", value: "", key: "unitWeight", required: false },
	// { td: "Примечание", value: "", key: "comment", required: false },
];
export const initialTTH = [
	{ td: "Тип ОТСС (модель)", value: "", key: "type", required: true },
	{ td: "Маркировка", value: "", key: "marking", required: false },
	{ td: "Заводской номер", value: "", key: "factoryNumber", required: false },
	{ td: "Сведения о сертификации", value: "", key: "specialInfo", required: false },
	// { td: "Объект воздействия", value: "", key: "influenceObject" },
];
export const initialLocation = [
	{ td: "Наименование сегмента", value: "", key: "name" },
	{ td: "Адрес размещения объекта", value: "", key: "address" },
];

export const initialIL = [
	{ td: "Наименование и тип технического средства", value: "", key: "name" },
	{ td: "Заводской номер", value: "", key: "factoryNumber" },
	{ td: "Сведения о сертификате", value: "", key: "certificate" },
];
